/**
 * Sikkerhedsnet for moerk-tilstand-udvidelser (24/9, Nicolai: "i nightmode er
 * det ikke 10/10").
 *
 * Siden er kun designet lys. Safari har ingen indbygget moerk tilstand for
 * websider, men udvidelser som Dark Reader og Noir farver siderne om. Dark
 * Reader lader siden vaere pga. darkreader-lock i doc-head-core. Andre
 * udvidelser goer det alligevel, og saa forsvinder logoets moerke tekst (et
 * billede, som de ikke roerer) og ViaBills tekst paa den moerke baggrund.
 *
 * Scriptet maaler headerens faktiske baggrund. Er den blevet moerk, faar <html>
 * klassen nt-moerk, og nt-custom.css vender logoet og ViaBill, saa de kan ses.
 * Chromes tvungne moerke tilstand virker ved tegningen og aendrer ikke de
 * beregnede farver, saa den fanges ikke her.
 */
(function () {
  function lysstyrke(farve) {
    var m = farve && farve.match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var d = m[1].split(',').map(function (x) { return parseFloat(x); });
    if (d.length === 4 && d[3] === 0) return null; /* gennemsigtig: kig paa foraelderen */
    var k = d.slice(0, 3).map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * k[0] + 0.7152 * k[1] + 0.0722 * k[2];
  }

  function baggrund(el) {
    while (el && el !== document.documentElement) {
      var l = lysstyrke(getComputedStyle(el).backgroundColor);
      if (l !== null) return l;
      el = el.parentElement;
    }
    return document.body ? lysstyrke(getComputedStyle(document.body).backgroundColor) : null;
  }

  function tjek() {
    var header = document.querySelector('.header');
    if (!header) return;
    var l = baggrund(header);
    var moerk = l !== null && l < 0.2;
    if (document.documentElement.classList.contains('nt-moerk') !== moerk) {
      document.documentElement.classList.toggle('nt-moerk', moerk);
    }
  }

  var planlagt = null;
  function senere() {
    clearTimeout(planlagt);
    planlagt = setTimeout(tjek, 150);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tjek);
  else tjek();
  window.addEventListener('load', function () {
    tjek();
    setTimeout(tjek, 1500);
  });

  /* Udvidelserne slaas til og fra via attributter paa <html> og style-elementer i <head> */
  if (window.MutationObserver) {
    new MutationObserver(senere).observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style', 'data-darkreader-mode', 'data-darkreader-scheme'] });
    if (document.head) new MutationObserver(senere).observe(document.head, { childList: true });
  }
})();
